import { Tabs } from 'animal-island-ui';
import SchedulePanel from './SchedulePanel';
import ShoppingPanel from './ShoppingPanel';
import TipsPanel from './TipsPanel';
import LedgerPanel from './LedgerPanel';
import InvitationPanel from './InvitationPanel';
import TodoPanel from './TodoPanel';

export default function Workbench({ eventId }: { eventId: number }) {
  const tabItems = [
    {
      key: 'schedule',
      label: (
        <span className="flex items-center gap-1">
          <span>📅</span>
          <span>日程</span>
        </span>
      ),
      children: <SchedulePanel eventId={eventId} />,
    },
    {
      key: 'todo',
      label: (
        <span className="flex items-center gap-1">
          <span>📋</span>
          <span>待办</span>
        </span>
      ),
      children: <TodoPanel eventId={eventId} />,
    },
    {
      key: 'shopping',
      label: (
        <span className="flex items-center gap-1">
          <span>🛒</span>
          <span>采购</span>
        </span>
      ),
      children: <ShoppingPanel eventId={eventId} />,
    },
    {
      key: 'ledger',
      label: (
        <span className="flex items-center gap-1">
          <span>💰</span>
          <span>账本</span>
        </span>
      ),
      children: <LedgerPanel eventId={eventId} />,
    },
    {
      key: 'tips',
      label: (
        <span className="flex items-center gap-1">
          <span>📜</span>
          <span>妙计</span>
        </span>
      ),
      children: <TipsPanel eventId={eventId} />,
    },
    {
      key: 'invitation',
      label: (
        <span className="flex items-center gap-1">
          <span>💌</span>
          <span>请帖</span>
        </span>
      ),
      children: <InvitationPanel eventId={eventId} />,
    },
  ];

  return (
    <div className="h-full">
      <Tabs
        defaultActiveKey="schedule"
        items={tabItems}
      />
    </div>
  );
}
